<template>
  <nav-bar title="钢瓶启用" />
  <cylinder-management />
  <van-form class="form">
    <Picker
      label="销售组"
      :columns="groupList"
      text="name"
      @confirm-values="(values) => (groupId = values.id)"
    />
  </van-form>
  <van-search
    v-model="words"
    placeholder="钢瓶查询"
    input-align="center"
    @search="onSearch"
  />
  <Content :bottom="76" :top="182" @content-scroll="handleContentScroll">
    <Loading v-show="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul v-if="list.length" class="code-list">
      <van-checkbox-group v-model="checked" ref="checkboxGroup">
        <li v-for="item in list" :key="item.gsId" class="code-list-item">
          <div class="code-list-item__title" @click="handleCodeClick(item.gsCode)">{{item.gsCode}}</div>
          <van-checkbox :name="item.gsId" shape="square" />
        </li>
      </van-checkbox-group>
    </ul>
    <loading-more :finished="finished" :showLoadingMore="showLoadingMore" :loadingFail="loadingFail" :list="list" @reload="reload()" />
  </Content>
  <div v-show="!showLoading" class="btn-conatiner van-hairline--top">
    <van-button
      block
      type="primary"
      native-type="button"
      :loading="btnLoading"
      :disabled="btnLoading"
      loading-text="请稍后..."
      @click="handleSubmitClick"
    >
      启用<span v-show="checked.length">（{{checked.length}}）</span>
    </van-button>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { reactive, ref, toRefs, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { cylinderPage, groupListByCompanyId, cylinderRelationOpen } from '@/api/cylinderManageUserHome'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import { useGetData } from '@/hooks/useGetData'
import { useStore } from 'vuex'
import { useSubmit } from '@/hooks/useSubmit'
export default {
  name: 'OpenCylinder', // 钢瓶启用
  setup () {
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const userId = computed(() => store.state.userInfo.id)
    const groupId = ref('')
    // 获取下拉选择值
    const selectValues = reactive({
      groupList: []
    })
    // 点击钢瓶
    const router = useRouter()
    const handleCodeClick = (id) => {
      router.push(`/cylinderinfoReAss/${id}`)
    }
    useGetData(groupListByCompanyId, (data) => {
      selectValues.groupList = data
    })({ companyId: companyId.value })

    // 选择钢瓶
    const checked = ref([])

    // 启用钢瓶
    const btnLoading = ref(false)
    const handleSubmitClick = () => {
      if (!groupId.value) {
        Toast('请选择销售组')
      } else if (!checked.value.length) {
        Toast('请选择钢瓶')
      } else {
        const params = {
          companyId: companyId.value,
          departmentId: groupId.value,
          cylinderIds: checked.value,
          operatorId: userId.value
        }
        const { onSubmit, loading } = useSubmit(cylinderRelationOpen, params, () => {
          init()
        })
        watch(loading, (val) => {
          btnLoading.value = val
        })
        onSubmit()
      }
    }

    // base
    const words = ref('')
    const searchWord = ref('') // 搜索关键词
    const data = useLoadingMore(cylinderPage)
    const {
      getList,
      list,
      finished,
      loadingFail,
      pageParams
    } = data

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.gsStatus = 8
      pageParams.page = 1
      pageParams.gsCode = searchWord.value
      pageParams.companyId = companyId.value
      finished.value = false
      loadingFail.value = false
      checked.value = []
      getList()
    }
    init()

    // search
    const onSearch = (value) => {
      searchWord.value = value
      init()
      words.value = ''
    }
    const loading = ref(false)
    return {
      ...toRefs(selectValues),
      ...data,
      words,
      onSearch,
      checked,
      handleSubmitClick,
      handleCodeClick,
      loading,
      groupId,
      companyId,
      btnLoading
    }
  }
}
</script>

<style lang="scss" scoped>
.form ::v-deep(.van-cell) {
  padding-top: 0;
}
.van-search {
  padding: 0 16px 16px 16px;
}
.code-list {
  padding: 16px 16px 0 16px;
  .code-list-item {
    padding: 10px 16px;
    font-size: 16px;
    background-color: #fff;
    display: flex;
    align-items: center;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    color: #666;
    &__title {
      flex: 1;
      margin-right: 10px;
    }
  }
}
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
</style>
